import { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

interface CountdownProps {
  remainingMinutes: number;
  setRemainingMinutes?: React.Dispatch<React.SetStateAction<number>>;
  onTick?: (remainingTime: string) => void;
  onCountdown: () => void;
}
const useCountTime = ({ remainingMinutes, setRemainingMinutes, onTick, onCountdown }: CountdownProps) => {
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);
  const endTimeRef = useRef<dayjs.Dayjs | null>(null);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    const now = dayjs();
    if (isRunning) {
      endTimeRef.current = now.add(remainingMinutes, 'minutes');

      intervalIdRef.current = setInterval(() => {
        const remainingTime = endTimeRef.current!.diff(dayjs(), 'seconds');
        if (remainingTime <= 0) {
          clearInterval(intervalIdRef.current!);
          onCountdown();
        } else {
          const minutes = Math.floor(remainingTime / 60);
          const seconds = remainingTime % 60;
          const remainingTimeStr = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
          onTick && onTick(remainingTimeStr);
        }
      }, 1000);
    }

    return () => clearInterval(intervalIdRef.current!);
  }, [isRunning]);

  const start = () => setIsRunning(true);
  const stop = () => setIsRunning(false);
  const setCountdown = (newRemainingMinutes: number) => {
    clearInterval(intervalIdRef.current!);
    setRemainingMinutes&&setRemainingMinutes(newRemainingMinutes);
    setIsRunning(true);
  };
  return {
    start,
    stop,
    setCountdown
  };
}
export default useCountTime
